import React, { useEffect, useState, useRef } from "react";
import { NavLink } from "react-router-dom";
import { mobileFooterTabs } from "../../../utils/constants/mobileFooter.constants";
import { useAppSelector } from "@hypexone/uicore";

const MobileFooter: React.FC = () => {
  const [navLinkWidth, setNavLinkWidth] = useState<number | null>(null);
  const navLinkRef = useRef<HTMLAnchorElement>(null);

  useEffect(() => {
    // Function to calculate the width of the first NavLink
    const calculateNavLinkWidth = () => {
      if (navLinkRef.current) {
        setNavLinkWidth(navLinkRef.current.offsetWidth);
      }
    };

    // Calculate on component mount
    calculateNavLinkWidth();

    // Optional: Adjust on window resize if needed
    window.addEventListener("resize", calculateNavLinkWidth);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("resize", calculateNavLinkWidth);
    };
  }, []);

  const leftPosition = navLinkWidth ? navLinkWidth * 2 : 0;
  const {langData} = useAppSelector((state) => state.cms);

  return (
    <>
      <div
        style={{
          left: `${leftPosition}px`,
          width: `${navLinkWidth}px`,
          transform: "translateZ(0)",
          height: "65px",
        }}
        className="fixed bg-blue4 rounded-t-full bottom-0 w-full z-10"
      // Ensure it is above content
      />

      <div
        className={`grid grid-cols-5 items-end fixed bottom-0 w-full bg-mobile-footer-background-color z-20`} // Fixed positioning and z-index to ensure it stays at the bottom
      >
        {mobileFooterTabs.map(({ title,langkey, imageSrc, navigationUrl }, index) => {
          const isHomeTab = title === "Home";
          const isAccountTab = title === "Account"; 
          const linkProps = isAccountTab
            ? { to: "/mobile-menu" }
            : { to: navigationUrl }; 

          return (
            <NavLink
              {...linkProps}
              key={title}
              className={({ isActive }) =>
                `flex flex-col items-center pt-2 h-[50px] ${isActive && !isHomeTab
                  ? "bg-selected-mobile-footer-custom-gradient"
                  : isActive && isHomeTab
                    ? "bg-blue4"
                    : ""
                }`
              }
              ref={index === 0 ? navLinkRef : null} // Only set ref for the first NavLink as width of all navLinks will be same as its grid
            >
              <img src={imageSrc} alt={title} className="h-[24px] w-[24px]" />
              <div className="text-white text-xs text-center">{title}</div>
            </NavLink>
          );
        })}
      </div>
    </>
  );
};

export default MobileFooter;
